import React, { useContext, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import CryptoContext from "../context/crypto/cryptoContext";
import ParameterContext from "../context/parameter/parameterContext";
const SingleCryptoChart = ({
  symbol,
  currencySymbol,
  localCurrency,
  larger,
}) => {
  const {
    compareCryptoCoinData1Sparkline,
    compareCryptoCoinData2Sparkline,
    cryptoCoinData1,
    cryptoCoinData2,
    getCompareCryptoCoinData1Sparkline,
    exchangeRate,
  } = useContext(CryptoContext);
  const { setTimeInChart, timeInChart } = useContext(ParameterContext);
  useEffect(() => {
    if (cryptoCoinData2 && cryptoCoinData1) {
      getCompareCryptoCoinData1Sparkline(cryptoCoinData1, cryptoCoinData2);
    }
    //eslint-disable-next-line
  }, [timeInChart, cryptoCoinData1, cryptoCoinData2]);
  // useEffect(() => {
  //   // if(cryptoCoinData1&& cryptoCoinData1.length > 0){
  //   //   setTimeout(() => {  getCompareCryptoCoinData1Sparkline(compareCryptoCoinData1[0].id)},3000)
  //   //   }
  //   // if(cryptoCoinData2&& cryptoCoinData2.length > 0){
  //   //   console.log("rendered "+compareCryptoCoinData2[0].id)
  //   //    setTimeout(() => {  getCompareCryptoCoinData2Sparkline(compareCryptoCoinData2[0].id)},4000)
  //   //   }
  // }, [timeInChart, localCurrency, cryptoCoinData1, cryptoCoinData2]);

  let options = {
    chart: {
      type: "spline",
      zoomType: "xy",
    },
    title: {
      text: `${cryptoCoinData1} vs ${cryptoCoinData2}`,
    },
    xAxis: {
      type: "datetime",
      dateTimeLabelFormats: {
        second: "%H:%M:%S",
        minute: "%H:%M",
        hour: "%H:%M",
        day: "%e %b",
        week: "%e %b",
        month: "%b '%y",
        year: "%Y",
      },
    },
    yAxis: [
      {
        labels: {
          formatter: function () {
            return (
              `${currencySymbol}` + this.axis.defaultLabelFormatter.call(this)
            );
          },
        },
        title: {
          text: "Price",
        },
        opposite: true,
      },
      {
        labels: {
          formatter: function () {
            return (
              `${currencySymbol}` + this.axis.defaultLabelFormatter.call(this)
            );
          },
        },
        title: {
          text: "Price",
        },
      },
    ],

    credits: {
      enabled: false,
    },
    series: [
      {
        name: cryptoCoinData1,
        showInLegend: true,
        data:
          compareCryptoCoinData1Sparkline &&
          compareCryptoCoinData2Sparkline &&
          compareCryptoCoinData1Sparkline.length > 0 &&
          compareCryptoCoinData2Sparkline.length > 0 &&
          compareCryptoCoinData1Sparkline[0].timestamps.map((i, index) => {
            return [
              new Date(i).getTime(),
              Number(
                Number(
                  compareCryptoCoinData1Sparkline[0]?.prices[index] /
                    exchangeRate
                ).toFixed(2)
              ),
            ];
          }),
      },
      {
        name: cryptoCoinData2,
        yAxis: 1,
        showInLegend: true,
        data:
          compareCryptoCoinData1Sparkline &&
          compareCryptoCoinData2Sparkline &&
          compareCryptoCoinData1Sparkline.length > 0 &&
          compareCryptoCoinData2Sparkline.length > 0 &&
          compareCryptoCoinData2Sparkline[0].timestamps.map((i, index) => {
            return [
              new Date(i).getTime(),
              Number(
                (
                  Number(compareCryptoCoinData2Sparkline[0]?.prices[index]) /
                  exchangeRate
                ).toFixed(2)
              ),
            ];
          }),
      },
    ],
  };

  return (
    <div className="SingleCryptoChart">
      <div className="SingleCryptoChart__container">
        <header>
          <section className="SingleCryptoChart__header__left"></section>
          <section className="SingleCryptoChart__header__right">
            <div
              onClick={() => setTimeInChart("1d")}
              style={{ background: timeInChart === "1d" ? "white" : "" }}
            >
              1d
            </div>
            <div
              onClick={() => setTimeInChart("7d")}
              style={{ background: timeInChart === "7d" ? "white" : "" }}
            >
              7d
            </div>
            <div
              onClick={() => setTimeInChart("1m")}
              style={{ background: timeInChart === "1m" ? "white" : "" }}
            >
              1m
            </div>

            <div
              onClick={() => setTimeInChart("1y")}
              style={{ background: timeInChart === "1y" ? "white" : "" }}
            >
              YTD
            </div>
            <div
              onClick={() => setTimeInChart("ally")}
              style={{ background: timeInChart === "ally" ? "white" : "" }}
            >
              All
            </div>
          </section>
        </header>
        <section className="SingleCryptoChart__chart">
          <center>
            <div className="SingleCryptoChart__watermark">
              Copyright © 2021 CoinStorey Pvt. Ltd. All rights reserved.
            </div>
            {compareCryptoCoinData1Sparkline &&
              compareCryptoCoinData2Sparkline &&
              compareCryptoCoinData1Sparkline.length > 0 &&
              compareCryptoCoinData2Sparkline.length > 0 && (
                <HighchartsReact
                  highcharts={Highcharts}
                  options={options}
                  allowChartUpdate={true}
                />
              )}
          </center>
        </section>
      </div>
    </div>
  );
};

export default SingleCryptoChart;
